var _g, _defs, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3534_12171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5 8C23.5 8 19.5 15.5 12 15.5C4.5 15.5 0.5 8 0.5 8C0.5 8 4.5 0.5 12 0.5C19.5 0.5 23.5 8 23.5 8Z",
    stroke: "#7E809F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12.5C14.4853 12.5 16.5 10.4853 16.5 8C16.5 5.51472 14.4853 3.5 12 3.5C9.51472 3.5 7.5 5.51472 7.5 8C7.5 10.4853 9.51472 12.5 12 12.5Z",
    stroke: "#7E809F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3534_12171"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    fill: "white"
  })))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 19,
    x2: 22,
    y2: 0.5,
    stroke: "#7E809F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeSlash);
export default __webpack_public_path__ + "static/media/eye-slash.b7ba2e854513b3a5b7adfa8342ea667d.svg";
export { ForwardRef as ReactComponent };